var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.DAY_TYPE = {
    DAY: 'DAY',
    WEEKDAY: 'WEEKDAY',
    WEEKEND: 'WEEKEND',
    MONDAY: 'MONDAY',
    TUESDAY: 'TUESDAY',
    WEDNESDAY: 'WEDNESDAY',
    THURSDAY: 'THURSDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY'
};

Object.freeze(Enum.MEEDY.DAY_TYPE);